<template>
    <primitive :object="mesh" />
</template>

<script setup lang="ts">
import { useRenderLoop } from '@tresjs/core';

const rows = 100;
const cols = 100;
const gap = 1;

const { onLoop } = useRenderLoop();

// Three.js é carregado dinamicamente: fica fora do bundle inicial,
// com tree-shaking nos imports nomeados. O <Suspense> no Background3D
// cobre o async setup deste componente.
const THREE = await import('three');

const geometry = new THREE.BoxGeometry(1, 1, 1);
const material = new THREE.MeshPhysicalMaterial({
    color: '#3a3a3a',      // Cinza escuro
    emissive: '#000000',   // Sem emissão própria
    metalness: 0.3,
    roughness: 0.2,
    reflectivity: 0.8,
    clearcoat: 0.6,
    clearcoatRoughness: 0.1
});

// Um único InstancedMesh (1 draw call) em vez de 10.000 meshes individuais.
const mesh = new THREE.InstancedMesh(geometry, material, rows * cols);
mesh.castShadow = true;
mesh.receiveShadow = true;

const dummy = new THREE.Object3D();

// Posição inicial do grid
for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
        dummy.position.set(
            (j - cols / 2) * gap,
            0,
            (i - rows / 2) * gap
        );
        dummy.updateMatrix();
        mesh.setMatrixAt(i * cols + j, dummy.matrix);
    }
}

onLoop(() => {
    const time = Date.now() * 0.001;

    for (let i = 0; i < rows; i++) {
        for (let j = 0; j < cols; j++) {
            const x = (j - cols / 2) * gap;
            const z = (i - rows / 2) * gap;
            const distance = Math.hypot(x, z);

            // Ajustando a amplitude baseada na distância do centro
            const amplitude = Math.max(0.5, 5 - distance * 0.1);
            dummy.position.set(x, Math.sin(distance * 0.1 - time) * amplitude, z);

            // Rotação sutil dos cubos
            dummy.rotation.x = Math.sin(time * 0.5) * 0.1;
            dummy.rotation.z = Math.cos(time * 0.5) * 0.1;
            dummy.updateMatrix();
            mesh.setMatrixAt(i * cols + j, dummy.matrix);
        }
    }
    mesh.instanceMatrix.needsUpdate = true;
});
</script>